import {EmailBanner} from './emailBanner';
import {EmailMessage} from './emailMessage';
import {ThirdPartyShare} from '../social-sharing/thirdPartyShare';
import {SocialMedia} from '../social-sharing/socialMedia';
import { TSMap } from 'typescript-map';
import {JsonObject, JsonProperty} from 'json2typescript';
import {TSStringToStringMapConverter} from '../../customJsonConverters/TSStringToStringMapConverter';
import {EmailMessageConverter} from '../../customJsonConverters/emailMessageConverter';
import {ThirdPartyShareConverter} from '../../customJsonConverters/ThirdPartyShareConverter';
import {SocialMediaConverter} from '../../customJsonConverters/socialMediaConverter';
import {Attachment} from './attachment';
import {Condition} from '../Conditions/Condition';
import {ConditionConverter} from '../../customJsonConverters/ConditionConverter';
import {MultipleCondition} from '../Conditions/MultipleCondition';
import {EmailContentDimensions} from './emailContentDimensions';


@JsonObject('Email')
export class Email {

    @JsonProperty('subject',TSStringToStringMapConverter)
    subject:TSMap<string,string> = new TSMap(); // { [key:string]:string; } = {}; // map

    @JsonProperty('expediter',TSStringToStringMapConverter)
    expediter: TSMap<string,string> = new TSMap();  // { [key:string]:string; } = {};

    @JsonProperty('attachments',TSStringToStringMapConverter)
    attachments: TSMap<string,Attachment> = new TSMap();

    @JsonProperty('emailBanners',[EmailBanner])
    emailBanners: Array<EmailBanner> = [];

    @JsonProperty('language',String,true)
    language = '';

    @JsonProperty('background_color',String,true)
    background_color = '';

    @JsonProperty('background_image',String,true)
    background_image = '';

    @JsonProperty('blocks',EmailMessageConverter)
    blocks = new EmailMessage();

    @JsonProperty('selectedCssTemplate')
    selectedCssTemplate  = 'style1';

    @JsonProperty('links',ThirdPartyShareConverter)
    links:TSMap<string,ThirdPartyShare> = new TSMap();

    @JsonProperty('socialSharing',SocialMediaConverter)
    socialSharing:Array<SocialMedia> = [];

    @JsonProperty('condition',ConditionConverter)
    condition: Condition = new MultipleCondition();

    @JsonProperty('dimensions',EmailContentDimensions)
    dimensions: EmailContentDimensions = new EmailContentDimensions();

    @JsonProperty('createdDate',String,true)
    createdDate:'2021-01-15 17h23';

    @JsonProperty('templateID',String,true)
    templateId = '';

    @JsonProperty('configPath',String)
    configPath = '';


    constructor() {
    }

}
